import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { USER } from '../actionTypes/actionTypes';
import { IErrorGlobal, IRootState, IUser } from '../model/store.model';

const initialState: IRootState = {
    user: undefined,
    isLoading: false,
    isLoggedIn: false,
    isError: {
        status: false,
        data: {
            httpCode: '',
            id: '',
            title: '',
            localizedDescription: '',
        },
    },
    breadcrumb: [],
};

const userSlice = createSlice({
    name: USER,
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<IUser>) => {
            const { payload } = action;
            state.user = { ...payload };
        },
        reset: (state) => {
            state.isLoading = false;
            state.isLoggedIn = false;
        },
        showSpinner: (state) => {
            state.isLoading = true;
        },
        hideSpinner: (state) => {
            state.isLoading = false;
        },
        showSnackbar: (state) => {
            state.isSnackbar = true;
        },
        hideSnackbar: (state) => {
            state.isSnackbar = false;
        },
        showSnackbarProfile: (state) => {
            state.isSnackbarProfile = true;
        },
        hideSnackbarProfile: (state) => {
            state.isSnackbarProfile = false;
        },
        showError: (state, action: PayloadAction<IErrorGlobal>) => {
            const { payload } = action;
            if (payload) {
                state.isError!.status = payload!.status;
                state.isError!.data!.id = payload.data!.id;
                state.isError!.data!.title = payload!.data!.title;
                state.isError!.data!.localizedDescription = payload!.data!.localizedDescription;
            }
        },
        hideError: (state) => {
            state.isError!.status = false;
            state.isError!.data!.id = '';
            state.isError!.data!.title = '';
            state.isError!.data!.localizedDescription = '';
        },
        showStopper: (state) => {
            state.isStopper = true;
        },
        hideStopper: (state) => {
            state.isStopper = false;
        },
    },
});

export const {
    setUser,
    reset,
    showSpinner,
    hideSpinner,
    showError,
    hideError,
    showSnackbar,
    hideSnackbar,
    showStopper,
    hideStopper,
    showSnackbarProfile,
    hideSnackbarProfile,
} = userSlice.actions;

export default userSlice.reducer;
